const compareFilterValues = (a, b) =>
  String(a ?? '').localeCompare(String(b ?? ''), undefined, {
    numeric: true,
    sensitivity: 'base'
  })

export const normalizeValueFilterValue = (value) =>
  String(value ?? '')
    .normalize('NFKC')
    .trim()

export const normalizeValueFilterSearch = (value) =>
  String(value ?? '')
    .normalize('NFKC')
    .trim()
    .replace(/[\u3041-\u3096\u309d-\u309f]/g, (kana) =>
      String.fromCharCode(kana.charCodeAt(0) + 0x60)
    )
    .toLocaleLowerCase()

export const buildValueFilterOptions = (items, field) => {
  const values = new Set()

  ;(items || []).forEach((item) => {
    values.add(normalizeValueFilterValue(item?.[field]))
  })

  return Array.from(values)
    .sort(compareFilterValues)
    .map((value) => ({ value, label: value === '' ? '-' : value }))
}

export const pruneUnavailableFilterValues = (
  selectedValues = [],
  options = []
) => {
  const availableValues = new Set(options.map((option) => option.value))
  return selectedValues.filter((value) => availableValues.has(value))
}
